function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import utils from './utils';
var configDefaults = {
  modelRadius: 2,
  meshColor: '#ff1b0c',
  meshInterval: 10,
  textureInterval: 100,
  mobileModel: false
};
var MODEL_REMOVE_TIMEOUTS = {};
export function getCityModelsFromUrl(_x) {
  return _getCityModelsFromUrl.apply(this, arguments);
}
function _getCityModelsFromUrl() {
  _getCityModelsFromUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(model) {
    var response, responseJson;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(model.url);
          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();
          case 6:
            responseJson = _context.sent;
            return _context.abrupt("return", responseJson.map(function (item) {
              return {
                model: _extends({}, model.settings, item)
              };
            }));
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));
  return _getCityModelsFromUrl.apply(this, arguments);
}
export function getCityModels(_x2) {
  return _getCityModels.apply(this, arguments);
}
function _getCityModels() {
  _getCityModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(cityModels) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(cityModels && cityModels.length > 0)) {
              _context2.next = 4;
              break;
            }
            _context2.next = 3;
            return Promise.all(cityModels.map(function (model) {
              return getCityModelsFromUrl(model);
            }));
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getCityModels.apply(this, arguments);
}
export var getModelConfig = function getModelConfig(configName, model, layer) {
  var value = configDefaults[configName];
  if (model[configName]) {
    value = model[configName];
  } else if (layer[configName]) {
    value = layer[configName];
  }
  return value;
};
export var findModelForHighlight = function findModelForHighlight(point, THREE_BOX) {
  var intersect = THREE_BOX.queryRenderedFeatures(point)[0];
  var intersectionExists = typeof intersect === 'object';
  var interactedObject;
  if (intersectionExists) {
    interactedObject = intersect.object;
    while (!interactedObject.modelId && interactedObject.parent) {
      interactedObject = interactedObject.parent;
    }
  }
  return {
    interactedObject: interactedObject,
    intersectionExists: intersectionExists
  };
};
export var highlightModelObject = function highlightModelObject(obj, highlightedObjects) {
  var depth = 0;
  if (obj.children) {
    obj.children.forEach(function (d) {
      if (d.material) {
        d.material.opacity = 0.8;
        highlightedObjects.push({
          obj: d,
          color: d.material.color.getHex()
        });
        d.material.color.setHex(0xf7b914);
      }
      var tmpDepth = highlightModelObject(d, highlightedObjects);
      if (tmpDepth > depth) {
        depth = tmpDepth;
      }
    });
  }
  return 1 + depth;
};
export var clearModelHighlights = function clearModelHighlights(highlightedObjects) {
  // Clear old objects
  highlightedObjects.forEach(function (h) {
    h.obj.material.opacity = 1;
    h.obj.material.color.setHex(h.color);
  });
  highlightedObjects.length = 0;
};

//TODO: refactor this function
export var getModelPath = function getModelPath(model) {
  var modelPath = model.modelPath;
  return modelPath;
};
export var shouldRenderModel = function shouldRenderModel(map, model, mapBbox, layerOptions) {
  return model.showOnZoom <= map.getZoom() && map.getZoom() <= model.maxZoomLevel && utils.intersectBbox(model.center, mapBbox, getModelConfig('modelRadius', model, layerOptions));
};
export var shouldLoadModel = function shouldLoadModel(map, model, modelConfig, THREE_MODELS) {
  var isMobile = typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
  if (isMobile && !model.mobileModel) {
    return false;
  }
  if (!modelConfig) {
    modelConfig = THREE_MODELS.find(function (m) {
      return m.id === model.id && m.index === model.index;
    });
  }
  return modelConfig && !modelConfig.loaded && !modelConfig.THREE_OBJECT && !modelConfig.loading;
};
export var positionModelsWithId = function positionModelsWithId(id, THREE_MODELS, map, mapBbox, layerOptions) {
  var modelConfigs = THREE_MODELS.filter(function (m) {
    return m.id === id;
  });
  modelConfigs.forEach(function (m) {
    var _m$THREE_OBJECT$rotat;
    if (!m.THREE_OBJECT) {
      return;
    }
    var origin = [].concat(m.center, [m.altitude]);
    m.THREE_OBJECT.scale.set(m.scale, m.scale, m.scale);
    (_m$THREE_OBJECT$rotat = m.THREE_OBJECT.rotation).set.apply(_m$THREE_OBJECT$rotat, m.rotate);
    m.THREE_OBJECT.setCoords(origin);
    m.THREE_OBJECT.visible = shouldRenderModel(map, m, mapBbox, layerOptions);
  });
};
export var setModelOptions = function setModelOptions(modelConfig, options, repeatable, THREE_MODELS) {
  var modelConfigs = repeatable ? THREE_MODELS.filter(function (m) {
    return m.id === modelConfig.id;
  }) : [modelConfig];
  var TB = window.THREE_BOX;
  modelConfigs.forEach(function (m) {
    Object.keys(options).forEach(function (prop) {
      if (prop === 'THREE_OBJECT' && options[prop]) {
        m[prop] = m[prop] || (modelConfig.index === m.index ? options[prop] : options[prop].duplicate());
        if (m.index !== modelConfig.index) {
          TB.add(m[prop]);
        }
      } else {
        m[prop] = options[prop];
      }
    });
  });
};

/**
 * render the model children one-by-one
 * @param sceneChildren
 * @param meshCount
 * @param model
 * @param materials
 * @param defaultMaterial
 * @param map
 * @param mapBbox
 * @param layerOptions
 * @returns {*}
 */
export var meshRenderer = function meshRenderer(sceneChildren, meshCount, model, materials, defaultMaterial, map, mapBbox, layerOptions) {
  if (meshCount === void 0) {
    meshCount = 0;
  }
  if (meshCount >= sceneChildren.length || !model.THREE_OBJECT) {
    return sceneChildren.length;
  }

  // set separate repeated object visibility
  if (!shouldRenderModel(map, model, mapBbox, layerOptions)) {
    model.THREE_OBJECT.visible = false;
  }

  //at the beginning set all existing materials to the default solid color until loaded
  materials.push(sceneChildren[meshCount].material);
  model.meshList.push(sceneChildren[meshCount].id);
  if (sceneChildren[meshCount].material) {
    sceneChildren[meshCount].material = defaultMaterial;
  }
  model.THREE_OBJECT.add(sceneChildren[meshCount].clone());
  model.added = true;
  map.triggerRepaint();
  return meshCount + 1;
};

/**
 * render the materials of the model one-by-one
 * @param materials
 * @param materialCount
 * @param repeatedModelConfigs
 * @param map
 * @returns {*}
 */
export var materialRenderer = function materialRenderer(materials, materialCount, repeatedModelConfigs, map) {
  if (materialCount === materials.length) {
    return materialCount;
  } else if (materialCount > materials.length) {
    return materials.length;
  }
  repeatedModelConfigs.forEach(function (m) {
    if (!m.THREE_OBJECT) {
      return;
    }
    var sceneChildren = m.THREE_OBJECT.children;
    if (sceneChildren[materialCount] && sceneChildren[materialCount].material !== undefined) {
      sceneChildren[materialCount].material = materials[materialCount].clone();
    }
  });
  map.triggerRepaint();
  return materialCount + 1;
};
export var toggleModelsVisibility = function toggleModelsVisibility(modelConfig, show) {
  if (modelConfig.THREE_OBJECT.visible && !show) {
    modelConfig.THREE_OBJECT.visible = false;
  } else if (!modelConfig.THREE_OBJECT.visible && show) {
    modelConfig.THREE_OBJECT.visible = true;
  }
};
export var findVisitPoi = function findVisitPoi(point, THREE_BOX) {
  // calculate objects intersecting the picking ray
  var intersect = THREE_BOX.queryRenderedFeatures(point)[0];
  //console.log("intersect>> ", intersect.object.parent.parent.visitURL);
  var intersectionExists = typeof intersect === 'object';
  var interactedObject;
  if (intersectionExists) {
    interactedObject = intersect.object;
  }
  return {
    interactedObject: interactedObject,
    intersectionExists: intersectionExists
  };
};

/**
 * When the model is out of view for some time, we need to remove it from memory.
 * In case of repeatable models we need to be sure that all the copies of the model
 * are out of the view before removing it.
 * To check this we keep the list of copies that are out and remove the model
 * only when all of them are invisible.
 *
 * @param modelKey
 * @param modelConfig
 * @param map
 * @param THREE_MODELS
 * @param THREE_BOX
 */
export var createModelRemovalTimeout = function createModelRemovalTimeout(modelKey, modelConfig, map, THREE_MODELS, THREE_BOX) {
  var repeatableCopies = THREE_MODELS.filter(function (m) {
    return m.id === modelConfig.id;
  });
  if (!MODEL_REMOVE_TIMEOUTS[modelKey]) {
    MODEL_REMOVE_TIMEOUTS[modelKey] = {
      repeatableItems: new Set([modelConfig.index])
    };
  }
  MODEL_REMOVE_TIMEOUTS[modelKey].repeatableItems.add(modelConfig.index);

  // in case all repeated copies of the model are out of view,
  // we can remove the model from memory
  if (!MODEL_REMOVE_TIMEOUTS[modelKey].timeout && MODEL_REMOVE_TIMEOUTS[modelKey].repeatableItems.size === repeatableCopies.length) {
    MODEL_REMOVE_TIMEOUTS[modelKey].timeout = setModelRemovalTimeout(repeatableCopies, map, THREE_BOX);
  }
};
export var disposeModels = function disposeModels(models, map, THREE_BOX) {
  models.forEach(function (m) {
    // remove the model from memory
    if (m.THREE_OBJECT) {
      utils.disposeTree(m, THREE_BOX);
      map.triggerRepaint();
      m.added = false;
      m.loaded = false;
    }
  });
};
export var disposeAllModels = function disposeAllModels(map, THREE_MODELS, THREE_BOX) {
  disposeModels(THREE_MODELS, map, THREE_BOX);
};
export var disposeModelWithId = function disposeModelWithId(id, map, THREE_MODELS, THREE_BOX, MODEL_IDS) {
  var i = THREE_MODELS.length;
  var modelConfigs = [];
  while (i--) {
    if (!THREE_MODELS[i].modelLow && !THREE_MODELS[i].modelHigh && THREE_MODELS[i].id === id || THREE_MODELS[i].modelLow && THREE_MODELS[i].id === id + '_low' || THREE_MODELS[i].modelHigh && THREE_MODELS[i].id === id + '_high') {
      modelConfigs.push(THREE_MODELS[i]);
      MODEL_IDS[THREE_MODELS[i].id] = 1;
    }
  }
  disposeModels(modelConfigs, map, THREE_BOX);
  return modelConfigs;
};

/**
 * Clear the timeout for removing a model from memory to keep it available
 *
 * @param modelKey
 * @param modelIndex
 */
export var clearModelRemovalTimeout = function clearModelRemovalTimeout(modelKey, modelIndex) {
  if (MODEL_REMOVE_TIMEOUTS[modelKey] && MODEL_REMOVE_TIMEOUTS[modelKey].timeout) {
    clearTimeout(MODEL_REMOVE_TIMEOUTS[modelKey].timeout);
    MODEL_REMOVE_TIMEOUTS[modelKey].timeout = null;
    MODEL_REMOVE_TIMEOUTS[modelKey].repeatableItems["delete"](modelIndex);
  }
};

/**
 * Remove the model form memory in a timeout
 *
 * @param repeatableCopies
 * @param map
 * @param THREE_BOX
 * @returns {number}
 */
function setModelRemovalTimeout(repeatableCopies, map, THREE_BOX) {
  return setTimeout(function () {
    repeatableCopies.forEach(function (m) {
      // remove the model from memory
      if (m.THREE_OBJECT) {
        utils.disposeTree(m, THREE_BOX);
        map.triggerRepaint();
        m.added = false;
        m.loaded = false;
      }
    });
  }, 20);
}